import { use } from 'react';
import { AppDataContext } from '../lib/app-data-hydration';
import { useOfflineSync } from '@/lib/hooks/use-offline-sync';
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';
import { RefreshCcw, RefreshCcwDot, RefreshCwOffIcon } from 'lucide-react';
import { PassageDataContext } from '@/data/passage/passage-data-context';

export function SidebarSync() {
    const context = use(AppDataContext);
    const { refresh } = context;
    const { data: sections } = use(PassageDataContext);

    const { state, sync } = useOfflineSync();
    if (!state) {
        return <></>;
    }
    const { status, itemsToSync } = state;

    function handleClick() {
        if (!itemsToSync.length) {
            refresh();
        }
        else {
            sync({ sections });
        }
    }

    return <>
        <SidebarMenu>
            <SidebarMenuItem>
                <SidebarMenuButton asChild tooltip="Sync" className="cursor-pointer">
                    <a onClick={handleClick}>
                        {status === 'ready' && itemsToSync.length > 0 && <>
                            <RefreshCcwDot color="orange" /><span>Sync {itemsToSync.length} Change{itemsToSync.length === 1 ? '' : 's'}</span>
                        </>}
                        {status === 'error' && <>
                            <RefreshCwOffIcon color="red" /><span>Error Syncing {itemsToSync.length} Change{itemsToSync.length === 1 ? '' : 's'}</span>
                        </>}
                        {status === 'syncing' && <>
                            <RefreshCcw className="refresh-icon-rotation" /><span>Syncing {itemsToSync.length} Change{itemsToSync.length === 1 ? '' : 's'}...</span>
                        </>}
                        {status === 'ready' && !itemsToSync.length && (
                            context.isUpdateAvailable ? (
                                <>
                                    <RefreshCcwDot className="text-orange-500 animate-pulse" />
                                    <span className="text-orange-500 font-medium">Update Available</span>
                                </>
                            ) : (
                                <>
                                    <RefreshCcw />
                                    <span>Synced</span>
                                </>
                            )
                        )}
                    </a>
                </SidebarMenuButton>
            </SidebarMenuItem>
        </SidebarMenu>
    </>;
}